import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils/index';

const logoVariants = cva('flex items-center', {
  variants: {
    size: {
      sm: 'gap-1.5',
      md: 'gap-2',
      lg: 'gap-3',
      xl: 'gap-3',
      '2xl': 'gap-4',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

const imageVariants = cva('object-contain', {
  variants: {
    size: {
      sm: 'h-6 w-auto',
      md: 'h-8 w-auto',
      lg: 'h-12 w-auto',
      xl: 'h-16 w-auto',
      '2xl': 'h-24 w-auto md:h-28',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export interface LogoProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof logoVariants> {}

export function Logo({ className, size, ...props }: LogoProps) {
  return (
    <div className={cn(logoVariants({ size }), className)} {...props}>
      <img
        src="/logo.svg"
        alt="COI LIVE"
        className={cn(imageVariants({ size }))}
      />
    </div>
  );
}
